import Popup from "../../components/Popup";
import {connect} from "react-redux";
import "pages/Styles/UIKit_v2.sass"

type Props = {
    title: string,
    subtitle?: string,
    onClose: Function,
    onConfirm: Function,
    confirmText?: string,
    cancelText?: string,
    subtitleAlign?: "center" | "left",
    /** z-index попапа (по умолчанию 10000). Задайте выше, чтобы открыть поверх другого попапа. */
    zIndex?: number
}

let ConfirmationPopup: any = function ConfirmationPopup(props: Props) {
    const {title, subtitle, onClose, onConfirm, confirmText = "Да", cancelText = "Нет", subtitleAlign = "center", zIndex = 10000} = props

    return <Popup
        style={{zIndex}}
        onClose={onClose}
    >
        <div>
            <div style={{marginBottom: "24px"}}>
                <div className="H3_21_v2" style={{textAlign: "center", whiteSpace: "pre-wrap", marginBottom: subtitle ? "12px" : "0"}}>
                    {title}
                </div>
                {
                    subtitle &&
                    <div
                        className="Body_16_v2_secondary"
                        style={{textAlign: subtitleAlign, whiteSpace: "pre-wrap"}}
                    >
                        {subtitle}
                    </div>
                }
            </div>

            <div className="confirmation-popup-buttons">
                <button
                    className="action-button secondary"
                    onClick={(e) => {onClose()}}
                >
                    <span className="button-text">{cancelText}</span>
                </button>
                <button
                    className="action-button primary"
                    onClick={(e) => {onConfirm()}}
                >
                    <span className="button-text">{confirmText}</span>
                </button>
            </div>
        </div>
    </Popup>
}

ConfirmationPopup = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(ConfirmationPopup)

export default ConfirmationPopup